import React from "react";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const useStyles = makeStyles((theme) => ({
    animatedSection: {
        opacity: 0,
        transform: 'translateY(30px)',
        transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
        '&.visible': {
            opacity: 1,
            transform: 'translateY(0)',
        },
    },
}));

export const AnimatedSection = ({ children, delay = 0 }) => {
    const classes = useStyles();
    const [ref, isVisible] = useScrollAnimation({ threshold: 0.1, once: true });

    return (
        <Box
            ref={ref}
            className={`${classes.animatedSection} ${isVisible ? 'visible' : ''}`}
            style={{ transitionDelay: `${delay}ms` }}
        >
            {children}
        </Box>
    );
};

